const CleanNumericInput = (value) => {
    if (typeof value !== 'string') value = String(value);
    const digitsOnly = value.replace(/\D/g, '');     // Step 1: Keep only numbers
    const noLeadingZeros = digitsOnly.replace(/^0+/, ''); // Step 2: Remove leading zeros
    return noLeadingZeros;
};

export default CleanNumericInput;